"use strict";function systemShare$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.systemShare$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.util.systemShare";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"4.5.11"},_a[ddSdk_1.ENV_ENUM.android]={vs:"4.5.11"},_a)),exports.systemShare$=systemShare$,exports.default=systemShare$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/util/systemShare.js
// module id = 1030
// module chunks = 106